import { createUseStyles } from 'react-jss';

import { ITheme } from '../../../styles/theme';
import { mediaQuery } from '../../../styles/helpers';
import { FontWeight } from '../../../styles/fonts';

export default createUseStyles<string>(
  ({ breakpoints }: ITheme) => ({
    root: {
      alignItems: 'center',
      display: 'flex',
      height: '100%',
      width: 'fit-content',
      gap: 4,

      '&:hover': {
        cursor: 'pointer',
      },
    },
    arrowIcon: {
      marginLeft: 10,
      '& > svg': {
        verticalAlign: 'middle',
        '& > path': {
          fill: 'var(--x-text-color-6)',
        },
      },
    },
    strong: {
      marginRight: 10,

      color: 'var(--x-accent-1-1)',
      fontWeight: FontWeight.Bold,

      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',

      [mediaQuery(breakpoints.tablet)]: {
        marginRight: 6,
      },
    },

    title: {
      display: 'flex',
      alignItems: 'center',
      fontSize: 16,
      lineHeight: '24px',
      fontWeight: FontWeight.SemiBold,
      color: 'var(--x-black)',
    },
  }),
  { name: 'AppHeader' },
);
